import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import axios from 'axios'
import { saveUser } from './redux/slices/userSlice'

function MmaCheck() {

  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {

    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')

    if (token) {
      axios
        .post('/api/auth/sso-login', { token })
        .then(res => {
          dispatch(saveUser(res.data))
          navigate('/healthcare')
        })
        .catch(err => {
          console.error(err)
          navigate('/')
        })
    }

  }, [navigate, dispatch])

  return (
    <div>
      Logging in...
    </div>
  )
}

export default MmaCheck